import {getMethod} from '~/api'

async function get() {
    return await getMethod('/cms/resorts')
}

export {get}
